import { cn } from "@/lib/utils.ts";
import React from "react";
import ReactMarkdown from "react-markdown";

/** Render markdown in an inline context, as just text with all the markdown formatting syntax stripped out. */
export const StripMarkdown = ({
  children,
  className,
  ...props
}: React.ComponentProps<typeof ReactMarkdown> & {
  className?: string;
}) => {
  return (
    <span className={cn("inline", className)}>
      <ReactMarkdown
        // don't need e.g. URL transform, because we don't support links
        allowedElements={[]}
        unwrapDisallowed={true}
        components={{}}
        {...props}
      >
        {children}
      </ReactMarkdown>
    </span>
  );
};
